/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Sort_Amount_AscInputs */



/**
* | output |
* | --- |
* | "amount due, low to high" |
*
* @param {Partner_Billing_Board_Sort_Amount_AscInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_sort_amount_asc = /** @type {((inputs?: Partner_Billing_Board_Sort_Amount_AscInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Sort_Amount_AscInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Betrag, aufsteigend")
	return /** @type {LocalizedString} */ ("amount due, low to high")
});